import React, {useContext, useEffect} from 'react';
import {ContextOperacion, ContextOperacionType} from "../../RefactorLayout";
import {useLoader} from "../../../../hooks/useLoader";
import {QueryStatus} from "../../../../types";
import {Alert, Grid} from "@mui/material";
import {useOperacionLCLS} from "./hooks/useOperacionLCLS";
import {OperacionLCLS} from "./types/types";
import {SeccionFirmas} from "../../components/SeccionFirmas";
import {SistemaTipo} from "../../../../types/enum/enum";
import SeccionLCLSDatosOperacion from "./components/SeccionLCLSDatosOperacion";
import SeccionLCLSLimitesTabla from "./components/SeccionLCLSLImitesTabla";


interface SistemaLCLSContentProps {
    operacion: OperacionLCLS
}

const SistemaLCLSContent = ({operacion}: SistemaLCLSContentProps) => {
    return (
        <>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <SeccionLCLSDatosOperacion
                        operacion={operacion}
                    />
                </Grid>

                <Grid item xs={12}>
                    <SeccionLCLSLimitesTabla operacion={operacion} />
                </Grid>

                <Grid item xs={12}>
                    <SeccionFirmas
                        codSistema={SistemaTipo.LCLS}
                        idOperacion={operacion.id}
                    />
                </Grid>
            </Grid>
        </>
    )
}

function SistemaLCLS() {
    const {idOperacion} = useContext<ContextOperacionType>(ContextOperacion);
    const {status, operacion} = useOperacionLCLS(idOperacion);
    const {showLoader, hideLoader} = useLoader();

    useEffect(() => {
        if (status === QueryStatus.Loading) {
            showLoader()
        } else {
            hideLoader();
        }
    }, [status]);

    if (!operacion) {
        return null;
    }

    if (status === QueryStatus.Error) {
        return (
            <Alert severity='error'>
                Se produjo un error al cargar la operación.
            </Alert>
        )
    }

    return (
        <SistemaLCLSContent
            operacion={operacion}
        />
    )
}

export default SistemaLCLS;